import cs from 'classnames';
import {
    Avatar,
    Space,
    Tooltip,
    Typography,
} from 'antd';
import { FC, useEffect, useState } from 'react';
import { FaCog, FaUserCircle } from 'react-icons/fa';
import { IoExitOutline } from 'react-icons/io5';
import { MdDeliveryDining } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useWorkspaceStore } from '../../store/workspace.store';
import { startLogout } from '../../store/auth.store';
import { SwitchLanguage } from '../SwitchLanguage';

const { Title } = Typography;

const Header: FC = () => {
    const { t } = useTranslation('shared', { keyPrefix: 'PAGES' });
    const workspace = useWorkspaceStore((state) => state.data);
    const [activeSettings, setActiveSettings] = useState<boolean>(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setActiveSettings(false);
        if (location.pathname.includes('/settings')) setActiveSettings(true);
    }, [location.pathname]);

    return (
        <div className="header">
            <Space size={12} align="center" style={{ width: '100%' }}>
                <Avatar
                    size={28}
                    src={<MdDeliveryDining size={20} style={{ verticalAlign: 'middle' }} />}
                    shape="square"
                    style={{ backgroundColor: 'var(--color-purple)' }}
                />
                <Title level={5} style={{ color: 'var(--color-purple)', margin: 0 }}>
                    {workspace?.name}
                </Title>
            </Space>
            <div className="header__content">
                <Tooltip title={t('SETTINGS')}>
                    <Avatar
                        size={28}
                        src={<FaCog className={cs('icon__inner', { 'icon__inner-active': activeSettings })} />}
                        className="icon"
                        onClick={() => navigate('/settings/general')}
                    />
                </Tooltip>
                <Tooltip title={t('PROFILE')}>
                    <Avatar
                        size={28}
                        src={<FaUserCircle className="icon__inner" />}
                        className="icon"
                        onClick={() => navigate('/profile')}
                    />
                </Tooltip>
                <SwitchLanguage />
                <Tooltip title={t('LOGOUT')}>
                    <Avatar
                        size={28}
                        src={<IoExitOutline className="icon__inner" />}
                        className="icon"
                        onClick={() => startLogout()}
                    />
                </Tooltip>
            </div>
        </div>
    );
};

export { Header };
